module.exports = __webpack_public_path__ + "media/favicon/favicon-2b03b7b3668c046c717d7e65bee2de49.ico";